module.exports = __webpack_public_path__ + "img/logo.867313af.png";